import { Protocol } from '../../Protocol';

export class ReportGroupProtocol {
  public static readonly GET_REPORT_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/reportgroups/all`; // 取得回報群組清單
  public static readonly GET_PAGEABLE_REPORT_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/reportgroups/pageable`; // 取得分頁回報群組清單
  public static readonly REPORT_GROUP_URL: string = `${Protocol.YATUNG_API_ROOT}/users/reportgroups`; // 回報群組清單通用url
}
